import React from 'react';
import DynamicNavBar from "../../Component/navbars/navbar";
import {IoIosAddCircleOutline} from "react-icons/io";


const items = [
    { icon: <IoIosAddCircleOutline />, label: "افزودن الگوریتم جدید" },
]


export default function BotManagement() {


    return (

        <div>

            <div className="px-6 text-3xl ">
                مدیریت ربات
            </div>

            <DynamicNavBar items={items}/>


        </div>
    )

}